export default __webpack_public_path__ + "img/BNonMVTW.ad2e6c64.svg";